import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsRotorSpinning = React.forwardRef(
  (props: SvgIconProps, ref: any) => {
    return (
      <SvgIcon {...props} ref={ref}>
        <g fill="currentColor">
          <path
            d="M20.8711281,11.5967827v-0.000001v-1.008091h-5.3428326v2.8226414h5.3428326v-1.008091h2.7218266v-0.8064585H20.8711281z
		 M20.0646477,12.5040569h-3.7299175v-1.2097006h3.7299175V12.5040569z"
          />
          <path
            d="M15.0242357,15.8307104l0.0000029,0.000021l0.7056665,0.8064585l-1.0080919,0.9072762l-0.8064585-0.8064594V6.858799
		l0.8064585-0.806459l1.512125,1.512125l1.9153671-1.9153666L14.7218132,2.221607l-3.2258587,3.2258594v4.2339501H7.5644307
		v4.4355574h3.830708v4.2339516l3.2258577,3.2258587l2.8226414-2.8226414l2.6210079,3.02425l0.6048489-0.504034
		l-5.1412249-5.9476824L15.0242357,15.8307104z M11.294322,13.4113312H8.3708887v-2.8226423h2.9234333V13.4113312z
		 M16.838768,18.1493149l-2.1169748,2.3185844l0.00002,0.0000248l-2.520215-2.4194012V5.8507066l2.4194002-2.4194007
		l2.3185825,2.3185835l-0.8064575,0.806459l-1.4113083-1.6129408l-1.6129408,1.6129408v10.5848751l1.512125,1.512125
		l1.4113092-1.4113083L16.838768,18.1493149z"
          />

          <rect
            x="19.2655449"
            y="13.0813761"
            transform="matrix(0.6119179 -0.7909213 0.7909213 0.6119179 -5.7828207 22.139246)"
            width="0.8064398"
            height="7.7620311"
          />
          <polygon points="16.3524513,14.9064455 16.3524513,14.9064455 16.3524494,14.9064436 	" />
          <path
            d="M3.6328936,14.9234562c-1.3105085-0.0000057-2.419389-1.1088877-2.419389-2.4194002
		c0-1.3105173,1.1088848-2.4194012,2.4194005-2.4194012V9.2781963c-1.8145496,0-3.2258592,1.512125-3.2258592,3.2258596
		c0,1.8145494,1.512125,3.2258587,3.2258592,3.2258587c1.8145499,0,3.2258592-1.512125,3.2258592-3.2258587H6.1530981
		C6.1530981,13.8145666,5.044219,14.9234505,3.6328936,14.9234562z"
          />
          <polygon
            points="4.0361223,10.6895056 4.4393635,11.3951721 6.4555225,9.9838638 6.4555225,9.2781982 4.4393635,7.8668885 
		3.9353297,8.5725546 5.4474549,9.6814394 	"
          />
        </g>
      </SvgIcon>
    );
  }
);

export default AppIconsRotorSpinning;
